/* @flow */

export default class CompanyDocumentActiveFilters {
  documentTypeId: number;

  constructor() {
    this.documentTypeId = 0;
  }
}
